import envConfig from '../utils/EnvironmentConfigs';
import Banner from '../components/Banner/Banner';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import Sidebar from '../components/Sidebar/Sidebar';
import { hasUnlockAdministratorAccess } from '../utils/AdminAccess';

const AppLayout = ({ children, sidebar, authDetails, onSignOut }) => {
    const showAnnouncementBanner = envConfig.showBanner;
    const tokenDetails = authDetails?.identity?.tokenParsed ?? {};
    const isUnlockAdministrator = hasUnlockAdministratorAccess(tokenDetails?.groups);
    const navLinks = [
        {
            label: 'Home',
            path: '/home',
        },
        {
            label: 'Requests',
            path: '/requests',
        },
        {
            label: 'Recertifications',
            path: '/recertifications',
        },
        {
            label: 'Approval tasks',
            path: '/approvals',
        },
        {
            label: 'Your access',
            path: '/user',
        },
        {
            label: 'Update profile',
            path: '/profile',
        },
        ...(isUnlockAdministrator
            ? [
                {
                    label: 'Admin Settings',
                    path: '/admin',
                },
            ]
            : []),
    ];

    return (
        <div className="app-shell">
            <a className="usa-skipnav" href="#main-content">
                Skip to main content
            </a>

            {showAnnouncementBanner ? (<Banner />) : null}

            <Header
                tokenDetails={tokenDetails}
                onSignOut={onSignOut}
                isUnlockAdministrator={isUnlockAdministrator}
            />

            <main id="main-content" className={sidebar ? 'app-main app-main--with-sidebar' : 'app-main'}>
                {sidebar ? (<Sidebar navLinks={navLinks}> {children} </Sidebar>) : (children)}
            </main>

            <Footer />
        </div>
    );
};

export default AppLayout;
